import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToAnchor() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.split('?')[0]; // Gets the hash but ignores things like query params
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'auto' }); // Scroll to the element
      }
    } else {
      window.scrollTo(0, 0); // Default to the top
    }
  }, [location]);
}
